import { PARTY } from "./shared";

export function PartyLogo({ party, size = 40, className = "" }) {
  const p = PARTY[party];
  if (!p) return null;
  if (!p.logo) {
    return (
      <span
        className={`inline-flex items-center justify-center rounded-full text-white font-bold ${className}`}
        style={{ width: size, height: size, background: p.solid, fontSize: size * 0.4 }}
        data-testid={`party-logo-${party}`}
      >
        I
      </span>
    );
  }
  return (
    <img
      src={p.logo}
      alt={`${p.name} logo`}
      width={size}
      height={size}
      className={`rounded-full bg-white shrink-0 ${className}`}
      style={{ width: size, height: size }}
      data-testid={`party-logo-${party}`}
    />
  );
}
